export const DefaultInit = 
{
  //Remember that this only initializes the field values and not the object value. The object values still needs to be initialized in FNA wizzard.
        //This should be changed in further updates to simplify the process should a default value change.
  marginalTax: 45,
  execFee: 3.5,
  execTax: true,
  spouseAccrual: true,
  
};



// WEBPACK FOOTER //
// ./src/views/Bna/bna_init.js